import React from 'react'
import { useTranslation } from 'react-i18next'
import { Download } from 'lucide-react'
import Button from './Button'
import MultiFileDownload from './MultiFileDownload'
import { useJobResults, useArchiveGeneration } from '../../hooks/useJobResults'

const JobDownloadButton = ({ job }) => {
  const { t } = useTranslation()
  const { generateArchive } = useArchiveGeneration()
  
  // Only fetch enhanced results for completed jobs
  const shouldFetch = job.status === 'completed' || job.status === 'finished'
  const { data: jobResults, isLoading, error } = useJobResults(job.id, shouldFetch)

  const handleArchiveGenerate = async () => {
    return await generateArchive(job.id)
  }

  // Show loading state while fetching enhanced results
  if (shouldFetch && isLoading) {
    return (
      <Button variant="outline" size="sm" disabled>
        <Download className="w-4 h-4 mr-1 animate-pulse" />
        {t('translation.loading', 'Loading...')}
      </Button>
    )
  }

  // If we have enhanced results, use the new multi-file component
  if (jobResults && jobResults.output_files) {
    return (
      <div className="min-w-0">
        <MultiFileDownload 
          jobResults={jobResults} 
          onArchiveGenerate={handleArchiveGenerate}
        />
      </div>
    )
  }

  // Fallback to legacy single download button
  if (error || !jobResults) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          // Use download_url from job data if available, otherwise fallback to result endpoint
          const downloadUrl = job.download_url || `/api/v1/user/jobs/${job.id}/result`
          window.open(downloadUrl, '_blank')
        }}
      >
        <Download className="w-4 h-4 mr-1" />
        {t('translation.download')}
      </Button>
    )
  }

  return null
}

export default JobDownloadButton